import { Component, computed, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { CategoriesService } from 'core';
import { BreadcrumbComponent } from '../../../blocks/breadcrumb/breadcrumb.component';
import { KorviuListComponent } from 'shared';
import { IKorviuListConfig, KorviuListItemTypes } from 'shared/types/korviu-list.config';
import { IFilter } from 'shared/types/filter.interface';
import { IGetPaginatedResponse } from 'shared/types/get-paginated-response.interface';
import { IPagination } from 'shared/types/pagination.interface';
import { ISorting } from 'shared/types/sorting.interface';
import { IProduct } from 'core/types/product.interface';
import { createRewardProductFilterSections, createRewardProductSortSections } from '../reward-list-options';

type RewardsListType = 'featured' | 'popular-in-community';

@Component({
  selector: 'app-reward-products-page',
  imports: [TranslatePipe, BreadcrumbComponent, KorviuListComponent],
  templateUrl: './reward-products-page.component.html',
  styleUrl: './reward-products-page.component.scss'
})
export class RewardProductsPageComponent {
  readonly #categoriesService = inject(CategoriesService);
  readonly #route = inject(ActivatedRoute);

  readonly listType = signal<RewardsListType>(this.#route.snapshot.data['rewardsListType'] ?? 'featured');
  readonly titleKey = computed(() =>
    this.listType() === 'featured' ? 'rewards.featured' : 'rewards.popularInYourCommunity'
  );

  readonly productListConfig: IKorviuListConfig = {
    getFn: this.getProducts.bind(this),
    sortSections: createRewardProductSortSections(),
    filterSections: createRewardProductFilterSections(),
    doNotSortFilterSections: true,
    itemType: KorviuListItemTypes.PRODUCT_LIST,
    totalLocalizableName: 'rewards.rewards',
    pagination: { pageSize: 12, page: 1 }
  };

  getProducts(
    pagination: IPagination,
    filters?: IFilter[],
    sorting?: ISorting
  ): Observable<IGetPaginatedResponse<IProduct[]>> {
    return this.listType() === 'featured'
      ? this.#categoriesService.getFeaturedProducts(pagination, filters, sorting)
      : this.#categoriesService.getPopularInCommunityProducts(pagination, filters, sorting);
  }
}
